<template>
  <div id="app">
    <router-view    />
  </div>
</template>
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
  export default {
  name: 'App',
  components: {
  },
  mounted() {
    const isMobile = /iPhone|iPad|iPod|Android/i.test(window.navigator.userAgent);

    if (isMobile) {
      this.$router.push({ path:"phoneIndex" }).catch(()=> {  })
    } else {
      this.$router.push({ path:'index' }).catch(()=> {  })
    }

  }
}
</script>

<style  >


    body {
      width: 100%;
      margin: 0;
      min-height: 100%;
      overflow-x: scroll;
    }
    .sub-title{
      color: #8F9298;
      font-size: 18px !important;
    }


    /* 文字扫描渐变核心样式 */
    .text-scan-gradient {
      /* 1. 核心配置：文字透明，裁剪背景到文字 */
      color: transparent;
      -webkit-background-clip: text;
      background-image: linear-gradient(90deg, #666, #666 40%, #2ec4a9 48%, #4edb83 52%, #666 60%, #666);
      /*linear-gradient(90deg, #666, #666 40%, gold 48%, orange 52%, #666 60%, #666)*/
      background-color: #666;
      background-size: 200% 100%;

      animation: textScan 8s  linear infinite;
    }

    @keyframes textScan {
       0% {
          background-position: 200% 0;
        }

        100% {
          background-position: -200% 0;
        }
    }
</style>
